export enum NumberFormat {
	DECIMAL_FORMAT = '0.2-2',
	INTEGER_FORMAT = '0.0',
}
